<template>
  <div class="print-layout min-h-screen bg-white" data-theme="Soleando">
    <slot />
  </div>
</template>

<script setup>
// Accept title prop
const props = defineProps({
  title: {
    type: String,
    default: "Soleando - Presupuesto",
  },
});

// Set head content for PDF pages
useHead({
  title: props.title,
  meta: [
    { name: "robots", content: "noindex" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
  ],
  bodyAttrs: {
    class: "print-body",
  },
  style: [
    {
      innerHTML: `
        @media print {
          body { 
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }
          
          .no-print {
            display: none !important;
          }
          
          .page-break {
            page-break-before: always;
          }
          
          .no-break {
            page-break-inside: avoid;
          }
        }
      `,
    },
  ],
});
</script>
